import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withCtx as _withCtx, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = ["data-test-id"]
const _hoisted_2 = {
  key: 0,
  class: "text-racq-dark-grey text-base-bold"
}
const _hoisted_3 = { class: "text-racq-med-grey text-m richtext" }

import { computed } from 'vue';

import type { ComponentRendering, Field } from '@sitecore-jss/sitecore-jss-vue';
import { Text, RichText, Image, Link } from '@sitecore-jss/sitecore-jss-vue';
import { ImageField } from '@sitecore-jss/sitecore-jss-vue/types/components/Image';

import { LinkPanelItem } from '@/interfaces/components/link-panel-item.interface';
import { PanelTitleTypes } from '@/enums/panel-title-type.enum';

import PanelTitle from '@/components/PanelTitle/PanelTitle.vue';
import BaseIcon from '@/components/BaseIcon/BaseIcon.vue';
import { LinkPanelIconSizes } from '@/enums/link-panel-enum';
import { ComponentFields } from '@sitecore-jss/sitecore-jss-vue';
import { usePageStore } from '@/store';
import { isEmptyObject } from 'jquery';
import { useRoute } from 'vue-router';
import { replaceBookmarksFromRoute } from '@/utils/bookmark.replace';

const maxSupportedLinkItems = 6;

export default /*@__PURE__*/_defineComponent({
  __name: 'LinkPanel',
  props: {
    bindings: {},
    heading: {},
    headingDescription: {},
    subheading: {},
    subheadingDescription: {},
    links: {},
    isGreyBackground: {},
    isArrowLinks: {},
    iconSize: {},
    globalIcon: {},
    globalButtonLabel: {},
    fields: {},
    rendering: {},
    handleLinkClickEvent: { type: Boolean, default: false },
    disabledPanel: { type: Boolean }
  },
  emits: ['btnClick'],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const outerClass = props.rendering?.params?.Styles;
const inlineStyle = props.rendering?.params?.inlineStyle;
const route = useRoute();
const dataTestId = usePageStore().dataTestId(props.rendering);
const isGrey = computed(() => (props.fields?.isGreyBackground ?? props.isGreyBackground)?.value ?? false);
const isArrowLinks = computed(() => (props.fields?.isArrowLinks ?? props.isArrowLinks).value);

const containerClasses = computed(() => ['max-w-176 w-full', (props.fields?.bindings ?? props.bindings)?.outerClass]);

const disabledClasses = computed(() => ['disabled:opacity-75  cursor-not-allowed', props.disabledPanel]);

const wrapperClasses = computed(() => [
  'border-[1.5px] border-solid rounded-lg shadow-md',
  isGrey.value ? 'bg-racq-neutral-grey' : 'py-2 bg-white',
]);

const contentGridClasses = computed(() => [
  isArrowLinks.value ? 'flex' : 'grid grid-cols-1 gap-1 md:grid-cols-5 md:gap-4',
]);

const textBlockClasses = computed(() => [isArrowLinks.value ? 'flex-grow' : 'col-span-2 md:col-span-4']);

const actionClasses = computed(() => [
  isArrowLinks.value ? 'ml-8 flex flex-col justify-center' : 'text-left md:text-right flex flex-col justify-center',
]);

const displayedLinks = computed(() => {
  const links = (props.fields?.items ?? props.links).slice(0, maxSupportedLinkItems);
  return links.map((link: any) => {
    const linkItem = link.fields?.link /** SC rendering */ ?? link.link; /** Page builder */
    // To replace querystring for links like cancel insurance /cancel roadside
    if (linkItem?.value?.querystring)
      linkItem.value.querystring = replaceBookmarksFromRoute(linkItem.value.querystring, route);
    return link;
  });
});

const isSize32Icons = computed(() => (props.fields?.iconSize ?? props.iconSize)?.value === LinkPanelIconSizes.Size32);
const iconSizeClasses = computed(() => (isSize32Icons.value ? 'w-[32px] h-[32px]' : 'w-[24px] h-[24px]'));

const emit = __emit;

const onClick = (linkItem: any) => {
  if (!props.handleLinkClickEvent) return;
  emit('btnClick', linkItem);
};

const getLinkField = (item: any) => {
  const originalLink = item.fields?.link ?? item.link;

  if (props.handleLinkClickEvent === true && originalLink?.value) {
    return {
      value: {
        ...originalLink.value,
        href: 'javascript:void(0)',
      },
    };
  }

  return originalLink;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([containerClasses.value, _unref(outerClass), disabledClasses.value]),
    "data-test-id": _unref(dataTestId),
    style: _normalizeStyle(_unref(inlineStyle))
  }, [
    ((_ctx.fields?.heading.value ?? _ctx.heading.value) || (_ctx.fields?.headingDescription.value ?? _ctx.headingDescription.value))
      ? (_openBlock(), _createBlock(PanelTitle, {
          key: 0,
          title: _ctx.fields?.heading ?? _ctx.heading,
          subTitle: _ctx.fields?.headingDescription ?? _ctx.headingDescription,
          isTextBlock: { value: true },
          bindings: { outerClass: 'mb-5' }
        }, null, 8, ["title", "subTitle"]))
      : _createCommentVNode("", true),
    (
        (_ctx.fields?.subheading.value ?? _ctx.subheading.value) ||
        (_ctx.fields?.subheadingDescription.value ?? _ctx.subheadingDescription.value)
      )
      ? (_openBlock(), _createBlock(PanelTitle, {
          key: 1,
          title: _ctx.fields?.subheading ?? _ctx.subheading,
          subTitle: _ctx.fields?.subheadingDescription ?? _ctx.subheadingDescription,
          panelType: { value: _unref(PanelTitleTypes).Subheading },
          bindings: { outerClass: 'mb-2' }
        }, null, 8, ["title", "subTitle", "panelType"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(wrapperClasses.value)
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(displayedLinks.value, (item, index) => {
        return (_openBlock(), _createBlock(_unref(Link), {
          key: index,
          disabled: _ctx.disabledPanel ? true : undefined,
          class: _normalizeClass([{
          'opacity-50 cursor-not-allowed':
            (((item.fields?.link ?? item.link).value.href?.length ?? 0) === 0 || _ctx.disabledPanel) &&
            !_ctx.handleLinkClickEvent,
        }, "group block hover:bg-racq-anti-flash-white active:bg-racq-white no-underline active:no-underline"]),
          field: getLinkField(item),
          "data-test-id": item.fields?.dataTestId?.value ?? item?.dataTestId?.value ?? item.name,
          onClick: ($event: any) => (onClick(item))
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", {
              class: _normalizeClass(["flex items-center py-5 mx-5 md:mx-8 border-racq-white", {
            'items-center': isSize32Icons.value,
            'items-start': !isSize32Icons.value,
            'border-b': index < displayedLinks.value.length - 1,
            'border-0': index == displayedLinks.value.length - 1,
          }])
            }, [
              ((_ctx.fields?.globalIcon ?? _ctx.globalIcon)?.value?.src || (item.fields?.icon ?? item.icon)?.value?.src)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: _normalizeClass(["flex mr-4 flex-shrink-0 items-center justify-center", iconSizeClasses.value])
                  }, [
                    _createVNode(_unref(Image), {
                      media: 
                ((_ctx.fields?.globalIcon && !_unref(isEmptyObject)(_ctx.fields?.globalIcon)) ?? _ctx.globalIcon)?.value?.src
                  ? _ctx.globalIcon
                  : (item.fields?.icon ?? item.icon)
              ,
                      class: "w-full h-auto"
                    }, null, 8, ["media"])
                  ], 2))
                : _createCommentVNode("", true),
              _createElementVNode("div", {
                class: _normalizeClass([contentGridClasses.value, "w-full"])
              }, [
                _createElementVNode("div", {
                  class: _normalizeClass(textBlockClasses.value)
                }, [
                  (item.fields?.title?.value || item.title?.value)
                    ? (_openBlock(), _createElementBlock("h4", _hoisted_2, [
                        _createVNode(_unref(RichText), {
                          field: item.fields?.title ?? item.title
                        }, null, 8, ["field"])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_3, [
                    _createVNode(_unref(RichText), {
                      field: item.fields?.subTitle ?? item.subTitle
                    }, null, 8, ["field"])
                  ])
                ], 2),
                _createElementVNode("div", {
                  class: _normalizeClass(actionClasses.value)
                }, [
                  (isArrowLinks.value)
                    ? (_openBlock(), _createBlock(BaseIcon, {
                        key: 0,
                        iconClass: "bg-icon-chevron",
                        class: "!w-4 !h-4"
                      }))
                    : (_openBlock(), _createBlock(_unref(Text), {
                        key: 1,
                        field: 
                    _ctx.globalButtonLabel?.value && _ctx.globalButtonLabel.value.trim() !== ''
                      ? _ctx.globalButtonLabel
                      : item.buttonLabel
                  ,
                        class: "underline text-base-bold group-hover:no-underline group-active:no-underline decoration-[10%]"
                      }, null, 8, ["field"]))
                ], 2)
              ], 2)
            ], 2)
          ]),
          _: 2
        }, 1032, ["disabled", "class", "field", "data-test-id", "onClick"]))
      }), 128))
    ], 2)
  ], 14, _hoisted_1))
}
}

})